module.exports = __webpack_public_path__ + "img/HE7102-01.68217939.jpg";